export default __webpack_public_path__ + "static/media/KMB.d52e466b.pdf";